/*
 * A collection of success message codes and their corresponding messages.
 * These can be reused throughout the application for consistency.
 */

export const SUCCESS_MESSAGES = {
    USER_REGISTERED_SUCCESSFULLY: "User registered successfully!!",
    USER_LOGGED_IN_SUCCESSFULLY: "User logged-in successfully!!",
    USER_LOGGED_OUT_SUCCESSFULLY: "User Logged-Out Successfully!!",

};

/*
 * A collection of error message codes and their corresponding messages.
 * These can be reused throughout the application for consistency in error handling.
 */

export const ERROR_MESSAGES = {
    AUTH: {
        /*----- Login ----- */
        EMPTY_USERNAME: "Username cannot be empty. Please enter your username.",
        EMPTY_PASSWORD: "Password cannot be empty. Please enter your password.",
        EMPTY_FIELDS: "All fields must be filled out. Please complete the form.",
        INVALID_TOKEN: "Invalid or missing token link.",

        /*----- Register ----- */
        EMPTY_FIRST_NAME: "First name cannot be empty.",
        INVALID_FIRST_NAME: "First name should contain only letters (A–Z or a–z).",
        EMPTY_LAST_NAME: "Last name cannot be empty.",
        INVALID_LAST_NAME: "Last name should contain only letters (A–Z or a–z).",
        EMPTY_EMAIL: "Email cannot be empty.",
        INVALID_EMAIL: "Please enter a valid email address.",
        EMPTY_CONTACT: "Contact cannot be empty.",
        INVALID_CONTACT: "Contact number must be exactly 10 digits and contain only numbers.",
        EMPTY_SUBSCRIPTION_PLAN: "Please select a subscription plan.",
        INVALID_PASSWORD: "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.",
    },
    VALIDATION: {

        EMPTY_USERNAME: "Username is required. Please provide your username.",
        EMPTY_PASSWORD: "Password is required. Please enter a password.",
        EMPTY_EMAIL: "Email is required. Please enter email.",
        EMPTY_CONFIRM_PASSWORD: "Please confirm your password.",
        EMPTY_CONTACT: "Phone is required. Please enter contact.",
        INVALID_EMAIL: "Invalid email address. Please enter a valid email.",
        SHORT_PASSWORD: "Password must be at least 8 characters long.",
        PASSWORD_MISMATCH: "The passwords do not match. Please try again.",
        EMPTY_FIRSTNAME: "First Name cannot be empty. Please enter your first name.",
        EMPTY_UID: "Aadhar/PAN Number cannot be empty. Please enter your Aadhar/PAN Number.",
        EMPTY_ENTRY_DATE: "Please provide the Tenant Entry Date before submitting.",
        EMPTY_ANNUAL_INCREMENT_DATE: "Please provide the Tenant Annual Increment Date before submitting.",
        EMPTY_RENT_PRICE: "Please provide the Rent Amount before submitting.",
        PASSWORD_SHOULD_MATCH_CONFIRM_PASSWORD: "Password & Confirm Password should be same.",

        /*----- Bulding ----- */
        EMPTY_BUILDING_NAME: "Building Name is required. Please provide building name.",
        EMPTY_BUILDING_ADDRESS: "Building Address is required. Please provide building address.",

        /*----- Property ----- */
        EMPTY_RENTAL_PROPERTY_NAME: "Property Name is required. Please provide property name.",
        EMPTY_RENTAL_PROPERTY_ADDRESS: "Property Address is required. Please provide property address.",
    },
};
